import React from 'react';
import PropTypes from 'prop-types';
import {
  BAGGAGE_PATH,
  BILLING_PATH,
  CARGO_PATH,
  TICKET_PATH,
} from '../../../../config/paths';
import { BILL_PROCESS_ORIGIN } from '../../../../config/constants';

const BillingViewButton = ({ flitDocumentId, billProcessId, origin }) => {
  if (!billProcessId) return null;

  const handleOpen = (e) => {
    e.stopPropagation();

    let url;

    switch (origin) {
      case BILL_PROCESS_ORIGIN.TICKET.value:
        url = `${TICKET_PATH}/${flitDocumentId}`;
        break;

      case BILL_PROCESS_ORIGIN.PARCEL.value:
        url = `${CARGO_PATH}/${flitDocumentId}`;
        break;

      case BILL_PROCESS_ORIGIN.EXCESS_BAGGAGE.value:
        url = `${BAGGAGE_PATH}/${flitDocumentId}`;
        break;

      default:
        url = `${BILLING_PATH}/${billProcessId}`;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      tabIndex={0}
      role="button"
      onClick={handleOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleOpen(e);
        }
      }}
      title="Ver detalle en otra pestaña"
      style={{
        cursor: 'pointer',
        width: '48px',
        height: '48px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: '1px solid #28a745',
        backgroundColor: 'white',
        color: '#28a745',
        fontSize: '11px',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <i
        className="fa fa-eye"
        style={{
          fontSize: '16px',
          marginBottom: '3px',
          color: '#28a745',
        }}
      />
      <span style={{ color: '#28a745', fontWeight: 'bold' }}>Ver</span>
    </div>
  );
};

BillingViewButton.propTypes = {
  billProcessId: PropTypes.number.isRequired,
  flitDocumentId: PropTypes.number,
  origin: PropTypes.string.isRequired,
};

BillingViewButton.defaultProps = {
  flitDocumentId: '',
};

export default BillingViewButton;
